export default {
  translation: {
    // header
    Discover: "Scopri",
    WhyQriend: "Perché QRiend?",
    LeaveMark: "Lascia il Segno",
    InstallNow: "Installa Ora",
    Login: "Accedi",
    Register: "Registrati",
    LogOut: "Esci",

    // footer
    HomePage: "Pagina Iniziale",
    QriendDescFooter: "Scopri nuove amicizie in ambienti sociali, incontra in modo sicuro e moderno!",
    Pages: "Pagine",
    PrivacyAndSecurity: "Privacy e Sicurezza",
    HomePage: "Home",
    QriendTeam: "Il Nostro Team",
    PrivacyPolicy: "Informativa sulla Privacy",
    TermsOfUse: "Termini di Utilizzo",
    DataSecurity: "Sicurezza dei Dati",
    CookiePolicy: "Politica sui Cookie",
    AccountSecurity: "Sicurezza dell'Account",
    LegalConsentAndDisclosureText: "Consenso Legale e Testo di Divulgazione",
    ChildSafetyPolicy: "Politica di Sicurezza per Minori",
    PrivacySettingsGuide: "Guida alle Impostazioni Privacy",
    SuitableForAllDevices: "Compatibile con Tutti i Dispositivi",
    DownloadNowFooter: "Scarica Ora, Espandi la Tua Rete Sociale!",

    // delete request
    DeleteRequestTitle: "Richiesta di eliminazione account",
    DeleteAccountQuestion: "Vuoi eliminare il tuo account?",
    Username: "Nome utente",
    Password: "Password",
    DeleteReason: "Perché vuoi eliminare il tuo account?",
    UsernamePlaceholder: "Inserisci il tuo nome utente",
    PasswordPlaceholder: "Inserisci la tua password",
    ReasonPlaceholder: "Spiega perché vuoi eliminare il tuo account...",
    SubmitDeleteRequest: "Invia richiesta di eliminazione",
    Warning: "Attenzione",
    WarningMessage: "L'eliminazione dell'account non può essere annullata. Tutti i tuoi dati saranno eliminati permanentemente.",
    RequestSubmittedSuccessfully: "Richiesta inviata con successo",
    RequestSubmittedMessage: "La tua richiesta di eliminazione account è stata ricevuta. Ti risponderemo il prima possibile.",
    SendNewRequest: "Invia nuova richiesta",
    UsernameRequired: "Il nome utente è richiesto",
    PasswordRequired: "La password è richiesta",
    ReasonRequired: "La ragione di eliminazione account è richiesta",

    // register page
    createAccount: "Crea account",
    createAccountDesc: "Registrati ora e inizia a incontrare nuove persone!",
    firstname: "Nome",
    lastname: "Cognome",
    username: "Nome utente",
    email: "Email",
    password: "Password",
    gender: "Genere",
    male: "Maschio",
    female: "Femmina",
    noGender: "Preferisco non dire",
    registerMain: "Registrati",
    registerDesc: "Hai già un account?",
    registerLogin: "Accedi",
    kvkkConsent: "Accetto gli accordi KVKK e sulla privacy",
    kvkkConsentRequired: "Devi accettare gli accordi KVKK e sulla privacy",
    privacyPolicy: "Informativa sulla privacy",
    termsOfUse: "Termini di utilizzo",

    // Landing Qriend Nedir?
    WhatIsQriend: "Cos'è QRiend?",
    WhatIsQriendDesc: "Ti permette di incontrare persone nello stesso posto con la tecnologia QR. Offre una piattaforma moderna e sicura per incontrare nuove persone in spazi sociali come bar, caffè e ristoranti.",
    RealProfile: "Profilo Reale",
    RealProfileDesc: "Interagisci solo con utenti reali verificati.",
    InstantMeetingOpportunity: "Opportunità di Incontro Istantaneo",
    InstantMeetingOpportunityDesc: "Puoi incontrare qualcuno che vedi nel locale tramite messaggistica istantanea.",
    VenueChats: "Chat del Locale",
    VenueChatsDesc: "QRiend offre socializzazione digitale nel tuo spazio.",

    // Landing Nasıl Tanışılır?
    HowtoMeet: "Come Incontrare Persone?",
    HowtoMeetDesc: "Con la nostra app, incontrare persone in tempo reale nella tua posizione attuale è ora incredibilmente facile! Ecco una guida passo-passo su come usarla;",
    EntryandConnectiontotheSpace: "Entra e Connettiti al Locale",
    EntryandConnectiontotheSpaceDesc: "Scansiona il codice QR con il tuo telefono",
    EntryandConnectiontotheSpaceDesc2: "Accedi all'app per unirti alla rete del locale",
    InSituExploration: "Esplorazione nel Locale",
    InSituExplorationDesc: "Vedi altri utenti attualmente nel locale",
    InSituExplorationDesc2: "Sfoglia i profili che ti interessano",
    CommunicationInitiation: "Inizio della Comunicazione",
    CommunicationInitiationDesc: "Invia messaggi alle persone che attirano la tua attenzione",
    CommunicationInitiationDesc2: "Connettiti facilmente con qualcuno con cui hai fatto contatto visivo",
    CommunicationInitiationDesc3: "Unisciti all'area chat di gruppo della tua posizione attuale",
    SafeSocialization: "Socializzazione Sicura",
    SafeSocializationDesc: "Conoscetevi attraverso messaggistica reciproca",
    SafeSocializationDesc2: "Puoi controllare o terminare la conversazione in qualsiasi momento",
    SafeSocializationDesc3: "Continua a incontrare nuove persone in modo divertente e sicuro",

    // Uygulamayı İndir Bölümü
    DownloadApp: "SCARICA L'APP E",
    DownloadApp2: "INIZIA A ESPLORARE!",
    DownloadAppDesc: "Disponibile su App Store e Google Play!",
    DownloadAppDesc2: "Scarica gratuitamente,",
    DownloadAppDesc3: "scopri le funzionalità premium.",

    // Discover
    DiscoverTitle: "Piattaforma Innovativa e Sociale che Facilita Appuntamenti Reali",
    DiscoverDesc: "Sei stanco di messaggi infiniti? Non vorresti sapere che sei nello stesso posto delle persone che vuoi incontrare nella vita reale? È esattamente per questo che la nostra app è diversa!",
    DiscoverEp2: "Sei pronto a verificare la tua presenza nei nostri locali partner con la tecnologia QR e incontrare persone reali nello stesso locale?",
    DiscoverEp2Dot: "Tracciamento delle Amicizie",
    DiscoverEp2DotDesc: "Segui i profili che ti piacciono e scopri i loro posti preferiti. Cogli l'opportunità di incontrare nuovi posti e nuove persone.",
    DiscoverEp3Dot: "Mi Piace di Profili e Locali",
    DiscoverEp3DotDesc: "Incontra nuove persone e scopri i tuoi posti preferiti attraverso i profili e i luoghi che ti piacciono.",
    DiscoverEp4Dot: "Incontra in Posizione",
    DiscoverEp4DotDesc: "A differenza delle app di appuntamenti ordinarie, con noi tutto è reale! Puoi vedere che sei nello stesso posto di qualcuno che ti piace e incontrarlo immediatamente.",
    SwiperText: "Interfaccia Conveniente",
    SafetyMeet: "Incontri Più Sicuri e Divertenti",
    RealTimeInteraction: "Interazione in Tempo Reale",
    RealTimeInteractionDesc: "Invece di perderti nel mondo virtuale, incontra persone che sono effettivamente nello stesso posto in questo momento",
    RealTimeInteractionDesc2: "Chi c'è nel tuo caffè preferito? Vedi istantaneamente e non perdere l'occasione di incontrare",
    RealTimeInteractionDesc3: "Grazie alla nostra tecnologia QR, verifica facilmente il locale in cui ti trovi",
    SecureAndVerifiedEnvironment: "Ambiente Sicuro e Verificato",
    SecureAndVerifiedEnvironmentDesc: "Socializza nei nostri locali partner",
    SecureAndVerifiedEnvironmentDesc2: "Con verifica della posizione reale, il rischio di profili falsi è minimo",
    SecureAndVerifiedEnvironmentDesc3: "Scopri e condividi i tuoi locali preferiti",
    BenefitsForBusinesses: "Vantaggi per le Aziende",
    BenefitsForBusinessesDesc: "Aumenta il traffico dei clienti",
    BenefitsForBusinessesDesc2: "Crea un ambiente con alta interazione sociale",

    // leave-mark
    LeaveMark: "Lascia il Segno",
    LeaveMarkTitle: "Lascia il Segno: Espandi la Tua Esperienza Sociale e Costruisci Connessioni agli Eventi",
    LeaveMarkDesc: "La funzionalità 'Lascia il Segno' di QRiend ti permette di espandere la tua esperienza sociale a concerti, festival, conferenze e molti altri eventi. Ora puoi incontrare nuove persone non solo nei locali, ma ad ogni evento a cui partecipi.",
    How2Use: "Come Funziona?",
    How2UseDot1: "Unisciti all'Evento",
    How2UseDot1Desc: "Vai a un concerto, festival, conferenza o qualsiasi evento",
    How2UseDot1Desc2: "Scansiona il codice QR speciale QRiend nel luogo dell'evento",
    How2UseDot1Desc3: "Connettiti istantaneamente alla chat dell'evento",
    How2UseDot2: "Scopri i Partecipanti all'Evento",
    How2UseDot2Desc: "Visualizza altri utenti QRiend che partecipano allo stesso evento",
    How2UseDot2Desc2: "Traccia in tempo reale quante persone sono attive nella chat dell'evento",
    How2UseDot2Desc3: "Trova persone che condividono i tuoi interessi",
    How2UseDot3: "Interazioni Speciali",
    How2UseDot3Desc: "Puoi inviare emoji speciali ai partecipanti che attirano la tua attenzione",
    How2UseDot3Desc2: "Le emoji inviate appaiono in tutta la chat come 'Utente A ha inviato un emoji cuore all'Utente B'",
    How2UseDot3Desc3: "L'invio di emoji è una funzionalità premium e rende più divertente incontrare persone agli eventi",
    WhereCanIUseIt: "Dove Posso Usarlo?",
    WhereCanIUseItDesc: "Il modo più facile per incontrare nuove persone in diversi ambienti, dai caffè ai concerti, festival ai ristoranti.",
    WhereCanIUseItDot1: "Lascia il Segno ai Concerti",
    WhereCanIUseItDot1Desc: "Scrivi qualcosa che lascerà il tuo segno al concerto a cui hai assistito.",
    WhereCanIUseItDot2: "Lascia il Segno nei Caffè",
    WhereCanIUseItDot2Desc: "Opportunità di socializzare in ampi circoli di amici nei caffè o pub",
    WhereCanIUseItDot3: "Uso in Bar e Discoteche",
    WhereCanIUseItDot3Desc: "Socializzazione nella vita notturna, serate a tema e opportunità di incontro sicure",
    DownloadApp: "Scarica l'App Mobile per Lasciare il Segno",

    // downloadPage
    DownloadNowNew: "Scarica Ora e Inizia",
    DownloadNowNew2: "a Incontrare Nuove Persone",
    DownloadNowNew3: "Oggi!",
    DownloadNowDesc: "In ogni locale in cui vai, incontra nuove persone con un solo codice QR!",
    SupportPlatforms: "Piattaforme e Dispositivi Supportati",
    SupportPlatformsDesc: "Accesso da Ovunque",
    SupportPlatformsDesc2: "Dispositivi Mobili",
    SupportPlatformsDescDot: "App iOS (ottimizzata per iPhone e iPad)",
    SupportPlatformsDescDot2: "App Android (tutti i telefoni e tablet Android)",

    // login ve register
    welcome: "Benvenuto",
    welcomeDesc: "Ci sei mancato! Per favore accedi per recuperare quello che ti sei perso.",
    email: "Email",
    password: "Password",
    forgotPassword: "Password dimenticata?",
    login: "Accedi",
    registerMain: "Registrati",
    loginDesc: "Non hai ancora un account?",
    loginReg: "Registrati",
    createAccount: "Crea Account",
    createAccountDesc: "Registrati ora e inizia a costruire nuove amicizie.",
    firstname: "Nome",
    lastname: "Cognome",
    username: "Nome Utente",
    gender: "Genere",
    password: "Password (Almeno 6 caratteri)",
    register: "Registrati",
    registerDesc: "Hai già un account?",
    registerLogin: "Accedi",
    rememberMe: "Ricordami",
    male: "Maschio",
    female: "Femmina",
    noGender: "Preferisco non specificare il genere",

    // Şifre Sıfırlama Onay - forgotPasswordConfirm.js

    passwordReset: "Resetta Password",
    passwordResetDesc: "Inserisci il codice a 6 cifre inviato al tuo indirizzo email e crea una nuova password.",
    verificationCode: "Codice di Verifica",
    codeValidityTime: "Tempo di Validità del Codice",
    newPassword: "Nuova Password",
    newPasswordPlaceholder: "Inserisci la nuova password",
    confirmPassword: "Conferma Password",
    confirmPasswordPlaceholder: "Conferma la tua password",
    resettingPassword: "Resetta Password...",
    resetPasswordButton: "Resetta Password",
    enterVerificationCode: "Inserisci il codice a 6 cifre di verifica.",
    passwordMinLength: "La password deve contenere almeno 6 caratteri.",
    passwordMismatch: "Le password non corrispondono!",
    passwordResetSuccess: "La tua password è stata reimpostata con successo!",
    passwordResetError: "Impossibile reimpostare la password, per favore riprova.",
    
  },
};